function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.426 16.721a6.007 6.007 0 1 0-6.007-5.993 6.046 6.046 0 0 0 6.007 5.993zM9.7 13.942a.878.878 0 0 1-.722-.4l-1.522-1.82a.8.8 0 0 1-.2-.572.743.743 0 0 1 1.376-.4l1.049 1.308 2.425-3.9a.8.8 0 0 1 .681-.409.728.728 0 0 1 .749.695.967.967 0 0 1-.177.572l-2.9 4.508a.854.854 0 0 1-.759.418z",
  transform: "translate(-4.419 -4.707)"
});

function SvgCheckedCircleDoneFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.014,
    viewBox: "0 0 12 12.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircleDoneFilled);
export default __webpack_public_path__ + "static/media/checked_circle_done_filled.66412352.svg";
export { ForwardRef as ReactComponent };